"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityRfpDetailsEntry = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const look_up_entity_1 = require("./look-up.entity");
const opportunity_rfp_tpa_detail_entity_1 = require("./opportunity-rfp-tpa-detail.entity");
const opportunity_rfp_insurer_detail_entity_1 = require("./opportunity-rfp-insurer-detail.entity");
const opportunity_rfp_client_contact_details_entity_1 = require("./opportunity-rfp-client-contact-details.entity");
const opportunity_rfp_credit_sharing_entity_1 = require("./opportunity-rfp-credit-sharing.entity");
const opportunity_rfp_details_entry_doument_map_entity_1 = require("./opportunity-rfp-details-entry-doument-map.entity");
let OpportunityRfpDetailsEntry = class OpportunityRfpDetailsEntry {
};
exports.OpportunityRfpDetailsEntry = OpportunityRfpDetailsEntry;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpDetailsEntry.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpDetailsEntry.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "activity_id", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpDetailsEntry.prototype, "activityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_activity_id", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpDetailsEntry.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "description", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityRfpDetailsEntry.prototype, "description", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "requirements", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityRfpDetailsEntry.prototype, "requirements", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "target_qcr_date", type: "date", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], OpportunityRfpDetailsEntry.prototype, "targetQcrDate", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "multiple_brokers_involved",
        type: "integer",
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpDetailsEntry.prototype, "multipleBrokersInvolved", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "is_market_allocation_done",
        type: "integer",
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpDetailsEntry.prototype, "isMarketAllocationDone", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "client_expectations", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityRfpDetailsEntry.prototype, "clientConsiderations", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "threats_from_existing_insurer",
        type: "text",
        nullable: true,
    }),
    tslib_1.__metadata("design:type", String)
], OpportunityRfpDetailsEntry.prototype, "threatsFromExistingInsurer", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "threats_from_existing_tpa",
        type: "text",
        nullable: true,
    }),
    tslib_1.__metadata("design:type", String)
], OpportunityRfpDetailsEntry.prototype, "threatsFromExistingBroker", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "extraneous_factors", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityRfpDetailsEntry.prototype, "extraneousFactors", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "strategy_plan", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityRfpDetailsEntry.prototype, "planForClosingDetail", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "remarks", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityRfpDetailsEntry.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpDetailsEntry.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], OpportunityRfpDetailsEntry.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], OpportunityRfpDetailsEntry.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamptz", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], OpportunityRfpDetailsEntry.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpDetailsEntry.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpDetailsEntry.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "status_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_e = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _e : Object)
], OpportunityRfpDetailsEntry.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_rfp_tpa_detail_entity_1.OpportunityRfpTpaDetail, (TpaDetails) => TpaDetails.opportunityRfpDetailsEntry),
    tslib_1.__metadata("design:type", Array)
], OpportunityRfpDetailsEntry.prototype, "tpaDetails", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_rfp_insurer_detail_entity_1.OpportunityRfpInsurerDetail, (insurerDetails) => insurerDetails.opportunityRfpDetailsEntry),
    tslib_1.__metadata("design:type", Array)
], OpportunityRfpDetailsEntry.prototype, "insurerDetails", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_rfp_client_contact_details_entity_1.OpportunityRfpClientContactDetail, (clientContactDetails) => clientContactDetails.opportunityRfpDetailsEntry),
    tslib_1.__metadata("design:type", Array)
], OpportunityRfpDetailsEntry.prototype, "clientContacts", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_rfp_credit_sharing_entity_1.OpportunityRfpCreditSharing, (creditSharaingDetails) => creditSharaingDetails.opportunityRfpDetailsEntry),
    tslib_1.__metadata("design:type", Array)
], OpportunityRfpDetailsEntry.prototype, "creditSharing", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_rfp_details_entry_doument_map_entity_1.OpportunityRfpDetailsEntryDocumentMap, (Documets) => Documets.opportunityRfpDetailsEntry),
    tslib_1.__metadata("design:type", Array)
], OpportunityRfpDetailsEntry.prototype, "documents", void 0);
exports.OpportunityRfpDetailsEntry = OpportunityRfpDetailsEntry = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "opportunity_rfp_details_entry" })
], OpportunityRfpDetailsEntry);
